import { render, staticRenderFns } from "./RemarkRow.vue?vue&type=template&id=69eb36a4"
import script from "./RemarkRow.vue?vue&type=script&lang=js"
export * from "./RemarkRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports